import React from 'react';
import { Component } from "src/types";

export interface ComponentPanel {
  panelId?: string;
  component: Component<any>;
}
export interface ComponentSelectorProps<T extends object> {
  components: ComponentPanel[],
  newTab: (panelId: string, id: string, props?: any, commands?: object) => string | undefined;
  panelId: string;
  commands: T;
}

const ComponentSelector = <T extends Object>(props: ComponentSelectorProps<T>) => {
  const {components, newTab, panelId, commands} = props;

  const addComponent = (id: string, componentPanelId?: string) => {
    try {
      newTab(componentPanelId ?? panelId, id, null, commands);
    } catch(error) {
      console.log(error);
    }
  }

  return (
    <div>
      <select className="combo">
        {
          components.map( componentPanel => 
            <option 
              id={componentPanel.component.id}
              value={componentPanel.component.id}
              onClick={() => addComponent(componentPanel.component.id, componentPanel.panelId)}
            >
              {componentPanel.component.title}
            </option>
          )
        }
      </select>
    </div>
  )
}

export default ComponentSelector;